import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import { beforeEachRouterEntry } from './beforeEachRouter'
import { overridePush } from './overridePush'
import auth from '@/mixins/auth'

// survey
const Survey = resolve => require(['@/views/Survey.vue'], resolve)
const SurveyBegin = resolve => require(['@/views/Survey/Begin.vue'], resolve)
const SurveySteps = resolve => require(['@/views/Survey/Steps.vue'], resolve)
const SurveyConclusion = resolve =>
  require(['@/views/Survey/Conclusion.vue'], resolve)

// home
const HomeInitial = resolve => require(['@/views/Home/Initial.vue'], resolve)

// audit logs
const HomeAuditLogs = resolve =>
  require(['@/views/Home/AuditLogs.vue'], resolve)

// user attributes
const HomeUserAttributes = resolve =>
  require(['@/views/Home/UserAttributes.vue'], resolve)
const HomeUserAttributesDetail = resolve =>
  require(['@/views/Home/UserAttributes/Detail.vue'], resolve)

// users
const HomeUsers = resolve => require(['@/views/Home/Users.vue'], resolve)
const HomeUsersSendInvites = resolve =>
  require(['@/views/Home/Users/UsersSendInvites.vue'], resolve)
const HomeUsersEdit = resolve =>
  require(['@/views/Home/Users/UsersEdit.vue'], resolve)
const HomeUsersProfile = resolve =>
  require(['@/views/Home/Users/UsersProfile.vue'], resolve)

// groups
const Groups = resolve => require(['@/views/Home/Groups.vue'], resolve)

// Custom Poll
const CustomPoll = resolve => require(['@/views/Home/CustomPoll.vue'], resolve)
// const CustomPollNew = resolve =>
//   require(['@/views/Home/CustomPoll/CustomPollNew.vue'], resolve)
const CustomPollReport = resolve =>
  require(['@/views/Home/CustomPoll/CustomPollReport.vue'], resolve)
// const CustomPollSurvey = resolve =>
//   require(['@/views/Home/CustomPoll/CustomPollSurvey.vue'], resolve)
// const SurveyPoll = resolve =>
//   require(['@/views/Home/CustomPoll/SurveyPoll.vue'], resolve)
// const SurveyPollInitial = resolve =>
//   require(['@/views/Home/CustomPoll/SurveyPollInitial.vue'], resolve)
// const SurveyPollFinal = resolve =>
//   require(['@/views/Home/CustomPoll/SurveyPollFinal.vue'], resolve)

const ActionPlan = resolve => require(['@/views/Home/ActionPlan.vue'], resolve)

const Analytics = resolve => require(['@/views/Home/Analytics.vue'], resolve)

const Benchmark = resolve => require(['@/views/Home/Benchmark.vue'], resolve)

const HomeFeedback = resolve => require(['@/views/Home/Feedbacks.vue'], resolve)
const HomeFeedbackTickets = resolve =>
  require(['@/views/Home/Tickets/Tickets.vue'], resolve)

const HomeReports = resolve => require(['@/views/Home/Reports.vue'], resolve)
const HomeReportsMetric = resolve =>
  require(['@/views/Home/Reports/Metric.vue'], resolve)

const HomeParticipation = resolve =>
  require(['@/views/Home/Participation.vue'], resolve)
const HomeComparation = resolve =>
  require(['@/views/Home/Comparation.vue'], resolve)

// Account
const AccountDetails = resolve =>
  require(['@/views/Home/Account/AccountDetails.vue'], resolve)
const AvailablesPlans = resolve =>
  require(['@/views/Home/Account/AvailablesPlans.vue'], resolve)
const Licenses = resolve =>
  require(['@/views/Home/Account/Licenses.vue'], resolve)
const Charging = resolve =>
  require(['@/views/Home/Account/Charging.vue'], resolve)
const ChargingSuccess = resolve =>
  require(['@/views/Home/Account/ChargingSuccess.vue'], resolve)
const Account = resolve => require(['@/views/Home/Account.vue'], resolve)
// const Documentation = resolve => require(['@/views/Documentation.vue'], resolve)

// Login
const Login = resolve => require(['@/views/Login.vue'], resolve)
const LoginAuth = resolve => require(['@/views/Login/Auth.vue'], resolve)
const LoginNew = resolve => require(['@/views/Login/New.vue'], resolve)
const LoginNewStripe = resolve =>
  require(['@/views/Login/NewStripe.vue'], resolve)
const LoginNewConfirm = resolve =>
  require(['@/views/Login/NewConfirm.vue'], resolve)
const LoginNewSuccess = resolve =>
  require(['@/views/Login/NewSuccess.vue'], resolve)
const LoginConfirmInvite = resolve =>
  require(['@/views/Login/ConfirmInvite.vue'], resolve)
const LoginConfirmAccount = resolve =>
  require(['@/views/Login/ConfirmAccount.vue'], resolve)
const LoginPassword = resolve =>
  require(['@/views/Login/Password.vue'], resolve)
const InviteResend = resolve =>
  require(['@/views/Login/InviteResend.vue'], resolve)
const LoginPasswordSent = resolve =>
  require(['@/views/Login/PasswordSent.vue'], resolve)
const LoginResetPassword = resolve =>
  require(['@/views/Login/ResetPassword.vue'], resolve)
const LoginPasswordSuccess = resolve =>
  require(['@/views/Login/PasswordSuccess.vue'], resolve)
const LoginPasswordSecretQuestion = resolve =>
  require(['@/views/Login/PasswordSecretQuestion'], resolve)

// Integrations
const HomeIntegrations = resolve =>
  require(['@/views/Home/Integrations.vue'], resolve)

// Culture
const HomeCulture = resolve => require(['@/views/Home/Culture.vue'], resolve)

// Custom Surveys
const CustomSurveysSurvey = resolve =>
  require(['@/views/CustomSurveysSurvey.vue'], resolve)

const CustomSurveysSurveyBegin = resolve =>
  require(['@/views/CustomSurveys/SurveyBegin.vue'], resolve)
const CustomSurveysSurveySteps = resolve =>
  require(['@/views/CustomSurveys/SurveySteps.vue'], resolve)
const CustomSurveysSurveyConclusion = resolve =>
  require(['@/views/CustomSurveys/SurveyConclusion.vue'], resolve)

const CustomSurveysCreate = resolve =>
  require(['@/views/CustomSurveysCreate.vue'], resolve)

const HomeCustomSurveys = resolve =>
  require(['@/views/Home/CustomSurveys.vue'], resolve)
const HomeCustomSurveysFeedbacks = resolve =>
  require(['@/views/Home/CustomSurveys/Feedbacks.vue'], resolve)
const HomeCustomSurveysFeedbacksDetail = resolve =>
  require(['@/views/Home/CustomSurveys/FeedbacksDetail.vue'], resolve)
const HomeCustomSurveysParticipation = resolve =>
  require(['@/views/Home/CustomSurveys/Participation.vue'], resolve)
const HomeCustomSurveysReports = resolve =>
  require(['@/views/Home/CustomSurveys/Reports.vue'], resolve)
const HomeCustomSurveysSettings = resolve =>
  require(['@/views/Home/CustomSurveys/Settings.vue'], resolve)

overridePush(Router)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    const scroll = Object.assign({ x: 0, y: 0 }, savedPosition)
    const html = document.querySelector('.body .content')
    if (html && html.scrollTo) html.scrollTo({ top: scroll.x, left: scroll.y })
    return scroll
  },
  routes: [
    { path: '*', redirect: 'dashboard' },
    {
      path: '/login',
      alias: ['/logout'],
      component: Login,
      children: [
        {
          name: 'login.auth',
          path: '/login',
          component: LoginAuth,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.new',
          path: 'new',
          component: LoginNew,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.new.stripe',
          path: 'new/stripe',
          component: LoginNewStripe,
          meta: {
            variant: 'bg-secondary',
          },
        },
        {
          name: 'login.new.success',
          path: 'new/success',
          component: LoginNewSuccess,
          meta: {
            variant: 'bg-secondary',
          },
        },
        {
          name: 'login.new.confirm',
          path: 'new/confirm/:token',
          component: LoginNewConfirm,
          props: true,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.confirm.invite',
          path: 'confirm-invite/:token',
          component: LoginConfirmInvite,
          props: true,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.confirm.account',
          path: 'confirm-account/:token',
          component: LoginConfirmAccount,
          props: true,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.password',
          path: 'password',
          component: LoginPassword,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.password.secret-question',
          path: 'secret-question',
          component: LoginPasswordSecretQuestion,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.password.sent',
          path: 'password/sent',
          component: LoginPasswordSent,
          meta: {
            variant: 'bg-secondary',
          },
        },
        {
          name: 'login.password.reset',
          path: 'reset-password/:token',
          component: LoginResetPassword,
          props: true,
          meta: {
            variant: 'bg-white',
          },
        },
        {
          name: 'login.password.success',
          path: 'password/success',
          component: LoginPasswordSuccess,
          meta: {
            variant: 'bg-secondary',
          },
        },
        {
          name: 'login.invite',
          path: 'login/invited/',
          component: InviteResend,
          meta: {
            variant: 'bg-secondary',
          },
        },
      ],
      beforeEnter: function(to, from, next) {
        const { ref } = to.query
        auth.isAuthenticated() ? (ref ? next(ref) : next('/dashboard')) : next()
      },
    },
    {
      path: '/survey',
      component: Survey,
      children: [
        {
          name: 'survey.steps',
          path: 'steps',
          component: SurveySteps,
          beforeEnter: function(to, from, next) {
            localStorage.surveyPage ? next() : next('survey')
            next()
          },
        },
        {
          name: 'survey.conclusion',
          path: 'conclusion',
          component: SurveyConclusion,
          beforeEnter: function(to, from, next) {
            from.name === 'survey.steps' && !localStorage.survey
              ? next()
              : next('survey')
          },
        },
        {
          name: 'survey.begin',
          path: ':type?',
          component: SurveyBegin,
          beforeEnter: function(to, from, next) {
            localStorage.surveyPage ? next('/survey/steps') : next()
          },
        },
      ],
    },
    // {
    //   path: '/custom-poll/survey',
    //   component: CustomPollSurvey,
    //   children: [
    //     {
    //       name: 'customPollSurvey.initial',
    //       path: '/custom-poll/survey/:pollId',
    //       component: SurveyPollInitial,
    //     },
    //     {
    //       name: 'customPollSurvey.survey',
    //       path: '/custom-poll/survey/:pollId/questions',
    //       component: SurveyPoll,
    //     },
    //     {
    //       name: 'customPollSurvey.final',
    //       path: '/custom-poll/survey/:pollId/final',
    //       component: SurveyPollFinal,
    //     },
    //   ],
    // },
    {
      name: 'custom-surveys.create',
      path: '/custom-surveys/create',
      component: CustomSurveysCreate,
      meta: {
        permission: 'page.admin-manager-access',
      },
    },
    {
      name: 'custom-surveys.survey',
      path: '/custom-surveys/:id/survey',
      component: CustomSurveysSurvey,
      children: [
        {
          name: 'custom-surveys.survey.steps',
          path: 'steps',
          component: CustomSurveysSurveySteps,
          // beforeEnter: function(to, from, next) {
          //   localStorage.surveyPage ? next() : next('survey')
          //   next()
          // },
        },
        {
          name: 'custom-surveys.survey.conclusion',
          path: 'conclusion',
          component: CustomSurveysSurveyConclusion,
          // beforeEnter: function(to, from, next) {
          //   from.name === 'survey.steps' && !localStorage.survey
          //     ? next()
          //     : next('survey')
          // },
        },
        {
          name: 'custom-surveys.survey.begin',
          path: ':type?',
          component: CustomSurveysSurveyBegin,
          // beforeEnter: function(to, from, next) {
          //   localStorage.surveyPage ? next('/survey/steps') : next()
          // },
        },
      ],
    },
    {
      path: '/dashboard',
      component: Home,
      beforeEnter: function(_to, _from, next) {
        if (!auth.isAuthenticated()) window.location = '/login'
        else next()
      },
      children: [
        {
          name: 'dashboard',
          path: '/',
          component: HomeInitial,
        },
        {
          name: 'audit-logs',
          path: '/audit-logs',
          component: HomeAuditLogs,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'audit-logs',
              to: '/management/data/audit-logs',
            },
          },
        },
        {
          name: 'user-attributes',
          path: '/user-attributes',
          component: HomeUserAttributes,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'demographic-attributes',
              to: '/management/people-and-groups/demographic-attributes',
            },
          },
        },
        {
          name: 'user-attributes.detail',
          path: '/user-attributes/:id',
          component: HomeUserAttributesDetail,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'demographic-attributes',
              to:
                '/management/people-and-groups/demographic-attributes/view/:id',
            },
          },
        },
        {
          name: 'integrations',
          path: '/integrations',
          component: HomeIntegrations,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'integrations',
              to: '/management/account/integrations/all',
            },
          },
        },
        {
          name: 'account',
          path: '/account',
          component: Account,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'account',
              to: '/management/account/engagement',
            },
          },
          children: [
            {
              default: true,
              name: 'account.details',
              path: '/account',
              component: AccountDetails,
              meta: {
                redirect: {
                  layoutRule: 'account',
                  to: '/management/account/engagement',
                },
              },
            },
            {
              name: 'account.plans',
              path: 'plans',
              component: AvailablesPlans,
              meta: {
                redirect: {
                  layoutRule: 'account',
                  to: '/management/account/engagement',
                },
              },
            },
            {
              name: 'account.licenses',
              path: 'licenses/:period',
              component: Licenses,
              meta: {
                redirect: {
                  layoutRule: 'account',
                  to: '/management/account/engagement',
                },
              },
            },
            {
              name: 'account.charging',
              path: 'charging',
              component: Charging,
              meta: {
                redirect: {
                  layoutRule: 'account',
                  to: '/management/account/engagement',
                },
              },
            },
            {
              name: 'account.charging.success',
              path: 'charging/success',
              component: ChargingSuccess,
              meta: {
                redirect: {
                  layoutRule: 'account',
                  to: '/management/account/engagement',
                },
              },
            },
          ],
        },
        {
          name: 'comparation',
          path: '/reports/comparation',
          component: HomeComparation,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'groups-comparison',
              to: '/engagement/comparison',
            },
          },
        },

        {
          name: 'custom-surveys',
          path: '/custom-surveys',
          component: HomeCustomSurveys,
          props: true,
        },
        {
          name: 'custom-surveys.feedbacks',
          path: '/custom-surveys/:id/feedbacks',
          component: HomeCustomSurveysFeedbacks,
          meta: {
            permission: 'page.admin-manager-access',
          },
          children: [
            {
              name: 'custom-surveys.feedbacks.tickets',
              path: '/custom-surveys/:id/feedbacks',
              component: HomeCustomSurveysFeedbacksDetail,
            },
            {
              name: 'custom-surveys.feedbacks.tickets.open',
              path: '/custom-surveys/:id/feedbacks/:ticketId',
              component: HomeCustomSurveysFeedbacksDetail,
            },
          ],
        },
        {
          name: 'custom-surveys.participation',
          path: '/custom-surveys/:id/participation',
          component: HomeCustomSurveysParticipation,
          meta: {
            permission: 'page.admin-manager-access',
          },
        },
        {
          name: 'custom-surveys.reports',
          path: '/custom-surveys/:id/reports',
          component: HomeCustomSurveysReports,
          meta: {
            permission: 'page.admin-manager-access',
          },
        },
        {
          name: 'custom-surveys.settings',
          path: '/custom-surveys/:id/settings',
          component: HomeCustomSurveysSettings,
          meta: {
            permission: 'page.admin-manager-access',
          },
        },

        {
          path: '/reports/',
          redirect: '/reports/company',
        },
        {
          name: 'reports',
          path: '/reports/:groupId',
          component: HomeReports,
          props: { groupId: 'company' },
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: ['climate', 'engagement-summary'],
              to: '/engagement/climate',
            },
          },
        },
        {
          path: '/culture',
          redirect: '/culture/company',
        },
        {
          name: 'culture',
          path: '/culture/:groupId',
          component: HomeCulture,
          props: { groupId: 'company' },
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'culture',
              to: '/engagement/culture',
            },
          },
        },
        {
          name: 'participation',
          path: '/participation/:groupId',
          component: HomeParticipation,
          props: true,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'participation',
              to: '/engagement/participation',
            },
          },
        },

        {
          name: 'customPoll',
          path: '/custom-poll',
          component: CustomPoll,
        },
        // {
        //   name: 'customPoll.new',
        //   path: '/custom-poll/new',
        //   component: CustomPollNew,
        //   meta: {
        //     permission: 'page.admin-manager-access',
        //   },
        // },
        // {
        //   name: 'customPoll.edit',
        //   path: '/custom-poll/edit/:pollId',
        //   component: CustomPollNew,
        //   props: true,
        //   meta: {
        //     permission: 'page.admin-manager-access',
        //   },
        // },
        {
          name: 'customPoll.report',
          path: '/custom-poll/:pollId/report-group/:groupId?',
          component: CustomPollReport,
          props: true,
          meta: {
            permission: 'page.admin-manager-access',
          },
        },

        {
          name: 'company.metric',
          path: '/reports/:groupId/metric/:metricId',
          component: HomeReportsMetric,
          props: true,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: ['climate', 'engagement-summary'],
              to: '/engagement/climate',
            },
          },
        },
        {
          name: 'feedbacks',
          path: '/feedbacks',
          component: HomeFeedback,
          meta: {
            redirect: {
              layoutRule: ['opinions', 'engagement-summary'],
              to: isManager =>
                isManager
                  ? '/engagement/opinions/received-opinions'
                  : '/engagement/opinions/me',
            },
          },
          children: [
            {
              name: 'feedbacks.tickets',
              path: '/tickets',
              component: HomeFeedbackTickets,
              meta: {
                redirect: {
                  layoutRule: ['opinions', 'engagement-summary'],
                  to: isManager =>
                    isManager
                      ? '/engagement/opinions/received-opinions'
                      : '/engagement/opinions/me',
                },
              },
            },
            {
              name: 'feedbacks.tickets.open',
              path: '/tickets/:ticketId',
              component: HomeFeedbackTickets,
              meta: {
                redirect: {
                  layoutRule: ['opinions', 'engagement-summary'],
                  to: isManager =>
                    isManager
                      ? '/engagement/opinions/received-opinions/:ticketId'
                      : '/engagement/opinions/me/:ticketId',
                },
              },
            },
          ],
        },
        {
          name: 'action.plan',
          path: '/action-plan',
          component: ActionPlan,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'action-plans',
              to: '/engagement/action-plan/action-plans',
            },
          },
        },
        {
          name: 'analytics',
          path: '/analytics',
          component: Analytics,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'climate',
              to: '/engagement/climate',
            },
          },
        },
        {
          name: 'dashboard.users',
          path: '/users',
          component: HomeUsers,
          meta: {
            permission: 'page.users',
            redirect: {
              layoutRule: 'management-people',
              to: '/management/people-and-groups/people',
            },
          },
        },

        {
          name: 'dashboard.users.profile',
          path: '/users/profile',
          component: HomeUsersProfile,
        },

        {
          name: 'dashboard.users.edit',
          path: '/users/edit',
          component: HomeUsersEdit,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'management-people',
              to: '/management/people-and-groups/people',
            },
          },
        },
        {
          name: 'dashboard.users.send.invite',
          path: '/users/sendInvites',
          component: HomeUsersSendInvites,
          meta: {
            permission: 'page.admin-access',
            redirect: {
              layoutRule: 'management-people',
              to: '/management/people-and-groups/people',
            },
          },
        },
        {
          name: 'dashboard.groups',
          path: '/groups/:groupId?',
          component: Groups,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'management-groups',
              to: '/management/people-and-groups/groups',
            },
          },
        },
        {
          path: '/benchmark',
          redirect: '/benchmark/company',
        },
        {
          name: 'benchmark',
          path: '/benchmark/:groupId',
          component: Benchmark,
          props: true,
          meta: {
            permission: 'page.admin-manager-access',
            redirect: {
              layoutRule: 'benchmark',
              to: '/engagement/benchmark/indicators',
            },
          },
        },
      ],
    },
    {
      name: 'performance',
      path: '/performance',
      meta: {
        redirect: {
          layoutRule: true,
          to: '/performance',
        },
      },
    },
    {
      name: 'growth',
      path: '/growth',
      meta: {
        redirect: {
          layoutRule: true,
          to: '/growth',
        },
      },
    },
    // {
    //   name: 'developer.doc',
    //   path: '/developer/doc',
    //   component: Documentation,
    // },
  ],
})

router.beforeEach(beforeEachRouterEntry)

export default router
